/**
 * 件数系データ列の最大値から、レポート件数系グラフの Y 軸（Chart.js scales.y.max）上限を返す。
 * - 最大値が 0 以下、または有限でないときは 100（全期間 0 や異常時は従来どおりの見え方）
 * - 最大値が正のときは 10 の倍数へ切り上げ（例: 15→20, 36→40, 123→130）
 */
export function getCountSeriesYAxisMax(maxValue: number): number {
  if (!Number.isFinite(maxValue) || maxValue <= 0) {
    return 100;
  }
  return Math.ceil(maxValue / 10) * 10;
}
